// allg. Utilities für Formulare
// ACHTUNG: es gibt noch in form.smarty.php ein "Test-JS" für eine simple Validierung
mp.form = {
    init: function () {
        // deaktivieren von Submitbuttons
        $(document).on('submit', 'form', mp.form.disableOnSubmit);

        // generelle Validierung mit Hilfe von Bootstrap
        $(document).on('submit', 'form.mpNeedsValidation', mp.form.bootstrapValidate);

        // nach Page-Load
        if ($('.custom-select.is-invalid,.form-control.is-invalid').length > 0) {
            mp.form.scroll2error();
        }

        // Kontakt zum Verkäufer
        $(document).on('click', '.mpVendorContactNumbersButton', mp.form.vendorShowNumbers)

        // Formular-Links in Modal
        $(document).on('click', '.mpFormLoadIntoModal', mp.form.loadIntoModal);
        $(document).on('click', '.mpSubmitModalBody', mp.form.submitModalBody);

        // PDF-Dialog
        $(document).on('click', '#mpMainimage,#mpAllImages,#mpSomeImages', mp.form.switchPdfOffer);

        // lokale Zeitausgabe im Modal
        $('#mpGenericModal').on('hidden.bs.modal', function () {
            mp.localtime.remove('#mpGenericModal ');
        });

        // Registrierung
        if ($('#mpFormRegister').length === 1) {
            $(window).on('hashchange', mp.form.registerHashChange);
            mp.form.registerHashChange();

            $(document).on('change keyup', '#mpFormRegister input,#mpFormRegister select', mp.form.registerForm);
            mp.form.registerForm();
        }

        // rund um LostPassword
        $('#mpFormLostPassword').parsley({excluded: ':hidden'});
        $('#mpFormResetPassword').parsley({excluded: ':hidden'});

        // pdf
        $(document).on('click', '.mpGeneratePdf', mp.form.closePdfDialog);

        // generisches File-Upload
        $('input.custom-file-input').on('change', function () {
            $(this).siblings('.custom-file-label').html($(this).val().replace('C:\\fakepath\\', " "));
        });

        // generischer POST
        $(document).on('click', '.mpGenericPost', mp.form.genericPost);
    },

    bootstrapValidate: function (ev) {
        var form = $(this);
        // Achtung: neu ist die Weiche für die Nutzung von parsley statt der nativen Validierung
        if ((form.hasClass('mpParsleyValidation') && form.parsley().validate() === false) ||
            (!form.hasClass('mpParsleyValidation') && form[0].checkValidity() === false)) {
            ev.preventDefault();
            ev.stopPropagation();
            mp.form.scroll2error();
            form.find('.mpDisableOnSubmit').prop('disabled', false);
        } else {
            // Submit im Modal wird per AJAX ausgeführt
            if (form.parents('.modal-body').length > 0) {
                ev.preventDefault();
                ev.stopPropagation();
                $.post(form.attr('action'), form.serialize(), function (result) {
                    if (form.parents('.modal-content').find('.mpSubmitModalBody').length === 1) {
                        form.parents('.modal-body').html(result).find('.form-group.submit').hide();
                    } else {
                        form.parents('.modal-body').html(result);
                    }
                    mp.localtime.init('#mpGenericModal '); // Leerzeichen ist absichtlich
                    form.find('.mpDisableOnSubmit').prop('disabled', false);
                });
            }
        }
        form.addClass('was-validated'); // bootstrap-CSS-Klasse
    },

    scroll2error: function () {
        window.setTimeout(function () {
            var errors = $('form').find('.custom-select.is-invalid,.form-control.is-invalid,.custom-select:invalid,.form-control:invalid,label.is-invalid');
            if (errors.length > 0) {
                var error = $(errors).find(':visible').first();
                if (error.length > 0) {
                    mp.form.scroll2errorAnimate(error, 50);
                } else {
                    // erweiterter Fall für Tabs wie bei den Sprachvarianten
                    error = $(errors).first();
                    if ($(error).parents('.tab-pane').length === 1) {
                        var tabId = $(error).parents('.tab-pane').attr('id');
                        var tabTrigger = $('a[href="#' + tabId + '"],[data-target="#' + tabId + '"]');
                        tabTrigger.trigger('click');
                        if ($(error).is(':visible')) {
                            // wir gehen aktuell davon aus, das die Tab-Auswahl sticky ist
                            var offsetAddon = Math.ceil(tabTrigger.parent().outerHeight());
                            mp.form.scroll2errorAnimate(error, 60 + offsetAddon);
                        }
                    }
                }
            }
        }, 20);
    },
    scroll2errorAnimate: function (error, offset) {
        if ($('.modal-backdrop.show').length > 0) {
            $('.modal.show').animate({scrollTop: error.offset().top - offset}, 500);
        } else {
            $('html, body').animate({scrollTop: error.offset().top - offset}, 500);
        }
    },

    vendorShowNumbers: function (ev) {
        ev.preventDefault();
        var ref = $(ev.target);
        var context = ref.parents('.row');
        ref.hide();
        $(ref.data('details')).appendTo(context.find('.mpVendorContactNumbers'));
        context.find('.mpVendorContactNumbers').show();
        mp.analytics.loadPage(document.location.pathname);
    },

    loadIntoModal: function (ev) {
        ev.preventDefault();

        var ref = $(this)
        $('#mpGenericModal .modal-dialog').addClass('modal-fixed');
        $('#mpGenericModal .modal-body').load(ref.attr('href'), function () {
            $('#mpGenericModal .modal-title').html(ref.text());

            if ($('#mpGenericModal .modal-body .form-group.submit input').length === 1) {
                $('#mpGenericModal .modal-body .form-group.submit').hide();
                $('#mpGenericModal .modal-footer').html('<button class="btn btn-primary mpMediumButton mpSubmitModalBody">' + $('#mpGenericModal .modal-body .form-group.submit input').val() + '</button>').show();
            }

            $('#mpGenericModal').modal('show');
            try {
                observerLozad.observe();
            } catch (e) {
            }
            mp.localtime.init('#mpGenericModal '); // Leerzeichen ist absichtlich

            mp.analytics.loadPage(ref.attr('href'));
        });

        return false;
    },
    submitModalBody: function (ev) {
        ev.preventDefault();
        $(this).parents('.modal-dialog').find('.modal-body form').trigger('submit');
    },

    switchPdfOffer: function (ev) {
        var val = $('input[name="imagesExport"]:checked').val();
        if (val === 'some') {
            $('#mpPdfOfferImagelist').show();
        } else {
            $('#mpPdfOfferImagelist').hide();
        }
    },

    registerForm: function () {
        $('#mpFormRegister').parsley({
            excluded: ':hidden'
        });

        // FIXME/ INFO: Diese Mechanik kann auch als Basis für Offer-Bearbeitung verwendet werden -> als globales Tool erweitern! siehe mp.formgroupVisibility

        var mode = $('input[name="registertypeFieldset[mode]"]:checked').val();
        $('[data-form-visible-name="mode"]').each(function () {
            if ($(this).data('form-visible-value') == mode) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });

        var type = $('input[name="registertypeFieldset[type]"]:checked').val();
        $('[data-form-visible-name="type"]').each(function () {
            if ($(this).data('form-visible-value') == type) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });

        $('[data-form-invisible]').each(function () {
            var config = $(this).data('form-invisible');
            if (typeof (config) == 'object') {
                if (config.mode == mode && config.type == type) {
                    $(this).hide();
                } else {
                    $(this).show();
                }
            }
        });
    },

    registerHashChange: function () {
        if (document.location.hash == '#buyer-vendor') {
            $('input[name="registertypeFieldset[mode]"][value="user"]').prop('checked', true).trigger('change');
        } else if (document.location.hash == '#commercial-vendor') {
            $('input[name="registertypeFieldset[mode]"][value="vendor"]').prop('checked', true).trigger('change');
        }
    },

    closePdfDialog: function () {
        // weil der Submit ansich erst durchlaufen muss, wird der Dialog mit einer Verzögerung von 2,3 Sekunden geschlossen
        setTimeout(function () {
            $('#mpGenericModal').modal('hide');
        }, 2300);
    },

    genericPost: function (ev) {
        ev.preventDefault();

        var action = $(this).data('action');
        var confirmTxt = $(this).data('confirm');

        var go = false;
        if (typeof (confirmTxt) != 'undefined') {
            if (confirm(confirmTxt)) {
                go = true;
            }
        } else {
            go = true;
        }

        if (go === true) {
            $.post(action, function (result) {
                if (result.success === true) {
                    document.location = document.location.href;
                } else {
                    alert(result.message);
                }
                //console.log(result);
            });
        }

        return false;
    },

    disableOnSubmit: function (ev) {
        $(ev.target).find('.mpDisableOnSubmit').prop('disabled', true);
    }
};

$(document).ready(function () {
    mp.form.init();
});
